'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _map2 = require('lodash/map');
var _map3 = _interopRequireDefault(_map2);
exports.default = computors;
var _computors = require('../utils/computors');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function computors(target) {
  var _annotationData = target.computors.annotationData;
  target.computors = (0, _extends3.default)({}, target.computors, {
    xValues: function xValues(data) {
      return (0, _map3.default)(target.computors.data(data), target.accessors.x);
    },
    xScale: function xScale(options, data, offset) {
      return (0, _computors.computeOrdinalScale)(options.axis.x.ordinal, target.computors.xRange(options, offset), target.computors.xValues(data));
    },
    xAxis: function xAxis(scale, pivot, options) {
      return (0, _computors.computeOrdinalAxis)(scale, options);
    },
    annotationData: function annotationData(options, scale, datum) {
      var limitWidth = scale.rangeBand();
      if (limitWidth < options.minWidth) {
        return [];
      }
      return _annotationData(options.display, scale);
    }
  });
}